module.exports = __webpack_public_path__ + "static/media/smartnav1-faster.0c4c9327.gif";